export const ROUTES = {
  LOGIN: '/login',
  SALES: '/ventas',
  CHARGES: '/cobrar',
  ROUTE: '/',
};
